import { logout } from '../../redux/actions'
import { connect } from 'react-redux'
import React, { Component } from 'react';

class Logout extends Component {

    componentDidMount() {
        this.props.logout();
        
    }

    render() {
        if (!this.props.isLogin) {
            this.props.user.user=null
            this.props.history.push("login")
        }
        return (
            <div>
                logout in progress
            </div>
        )
    }
}
const mapStateToProps = (state) => (

    {
        user:state.user,
        isLogin: state.login.isLogin
    })

const mapDispatchToProps = {
    logout
}

export default connect(mapStateToProps, mapDispatchToProps)(Logout)